import React, { useContext, useEffect } from 'react';
import PrivatePage from '../../components/PrivatePage';
import { isLoggedIn } from '../../lib/utils';
import { AccountContext } from '../../providers/accountProvider';
import WriterContainer from './WritersAcademy.container';
import WritersAcademyUI from './WritersAcademy.UI';

const WriterAcademy = (props) => {
  const { user } = useContext(AccountContext);
  const isUserLogged = isLoggedIn();

  useEffect(() => {
    if (!isUserLogged) {
      // Hide the widget asynchronously after the initial render
      setTimeout(() => {
        window?.fcWidget?.hide();
      }, 0);
    }
  }, [isUserLogged]);

  if (!isUserLogged) {
    return (
      <WriterContainer {...props}>
        {/* Load WritersAcademyUI without PrivatePage for non-logged-in users */}
        <WritersAcademyUI isLoggedIn={isUserLogged} />
      </WriterContainer>
    );
  }

  return (
    <PrivatePage>
      <WriterContainer {...props}>
        <WritersAcademyUI isLoggedIn={isUserLogged} user={user} />
      </WriterContainer>
    </PrivatePage>
  );
};

export default WriterAcademy;
